<template>      
<div key=8>   

          <div v-if="loading == 0" class="card-body">
            
            <div class="row">
              <div class="col-12">
                <self-building-square-spinner :animation-duration="6000" :size="60" color="#0E1698" style="margin: auto"/></span>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="text-center" style="text:#0E1698">Loading your Build</div>
              </div>
            </div>
          </div>



          <div v-if="loading == 1" class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="h5 text-muted">Build</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <span class="text-muted">Name: </span>{{buildDetails.build_name}}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12">
                <span class="text-muted">Created: </span>{{buildDetails.created_at | moment("MM-DD-YYYY") }}
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <span class="text-muted">Product: </span>{{ buildProduct.name }}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12">
                <span class="text-muted">Product Price: </span>{{ buildDetails.base_price | currency }}
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                {{ buildOptions.length }} x Optionals
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12">
                <span class="text-muted">Optionals Price: </span>{{ buildDetails.opt_price | currency  }}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12">
                <span class="text-muted">Subtotal: </span>{{ buildDetails.tot_price | currency  }}
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <a href="#" class="small" @click="changeBuild">Change Build</a>
              </div>
            </div>
          </div>

          
</div>
</template>


<script>
import { SelfBuildingSquareSpinner  } from 'epic-spinners'
import {store} from '../../../stores/quote-builder-main-store.js'


export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      loading: 0,
      buildDetails: [],
      buildProduct: [],
      buildIncludes: [],
      buildOptions: [],
    }
  },
  computed: {

    
  },
  watch: {
    
  },
  mounted() {
    this.getBuildInformation();
  },
  methods: {
    getBuildInformation() {
      var _this = this;
      _this.loading = 0;
      axios.get('/builder/utility/build/getspecificbuild/' + _this.prop2[0])
        .then(function (response) {
          var a = response.data.data;
          console.log(a);
          _this.buildDetails = response.data.data;
          _this.buildProduct = _this.buildDetails.product;
          _this.buildIncludes = _this.buildDetails.product.includes;
          _this.buildOptions = _this.buildDetails.options;
          _this.loading = 1;
        });
    },
    changeBuild() {
      var _this = this;
      _this.$emit('onBuildSecondary', [ 'build-summary' ])
    },


  },    
  components:{
    SelfBuildingSquareSpinner,
  },
  filters: {

  }
}
</script>
